// extracted by mini-css-extract-plugin
module.exports = {"view-content":"styles__view-content__3TXkQ","viewContent":"styles__view-content__3TXkQ","wrapper":"styles__wrapper__2B6LS"};